export default async (router) => {
  // console.log('theme_a init')

  
}